import { Component, OnInit } from '@angular/core';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ClinicService } from 'src/app/_services/clinic.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sales-orders',
  templateUrl: './sales-orders.component.html',
  styleUrls: ['./sales-orders.component.scss'],
})
export class SalesOrdersComponent implements OnInit {
  orders: any[] = [];
  loading: boolean = true;
  exportLoading: boolean = false;
  filteringFor: string = '';
  products: any[] = [];
  clinics: any[] = [];

  metaData = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  orderColumns: any[] = [
    { field: 'order_number', header: 'Order Number' },
    { field: 'clinic.name', header: 'Clinic' },
    { field: 'order_date', header: 'Order Date' },
    { field: 'date_required', header: 'Required Date' },
    { field: 'order_status', header: 'Status' },
    { field: 'order_total', header: 'Total' },
    { field: 'clinic.professional_nurse', header: 'Professional Nurse' },
    { field: 'clinic.province', header: 'Province' },
  ];
  selectedClinic: any;

  filterForm: FormGroup = new FormGroup({
    clinic_id: new FormControl(''),
    order_number: new FormControl(''),
    date_from: new FormControl(''),
    date_to: new FormControl(''),
  });

  constructor(
    private clinicProductService: ClinicProductService,
    private dialogService: DialogService,
    private clinicService: ClinicService
  ) {}

  ngOnInit(): void {
    this.getClinics();
  }

  getClinics() {
    this.clinicService.getClinics().subscribe(
      (response: any) => {
        this.clinics = response.body.data;
        console.log('Clinics:', this.clinics);
      },
      (error) => {
        console.error('Error fetching clinics:', error);
      }
    );
  }

  getFilterInputValue(event: any) {
    const inputelement = event.target as HTMLInputElement;
    this.filteringFor = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringFor = '';
    }
    return inputelement.value;
  }

  lazyLoadOrders(event: any) {
    this.loading = true;
    this.metaData = {
      ...this.metaData,
      limit: event.rows || 100,
      offset: event.first || 0,
      globalFilter: event.globalFilter || '',
      loading: true,
      sort: event.sortField
        ? event.sortOrder === -1
          ? `-${event.sortField}`
          : event.sortField
        : '',
    };

    this.clinicProductService.getOrders(this.metaData).subscribe(
      (response: any) => {
        this.orders = response.body.data;
        this.metaData.totalRecords = response.body.count;
        console.log('Orders:', this.metaData.totalRecords);

        this.clinicProductService.updateOrders(this.orders);

        this.metaData.loading = false;
      },
      (error) => {
        console.error('Error fetching orders:', error);
        this.loading = false;
      }
    );
  }

  exportOrders() {
    this.exportLoading = true;
    const filters = { ...this.filterForm.value };

    // Remove empty values so backend won't see ""
    Object.keys(filters).forEach((key) => {
      if (filters[key] === '' || filters[key] == null) {
        delete filters[key];
      }
    });

    // Format date fields to ISO if present
    if (filters.date_from)
      filters.date_from = this.formatDate(filters.date_from);
    if (filters.date_to) filters.date_to = this.formatDate(filters.date_to);

    this.clinicService.exportOrdersToExcel(filters).subscribe({
      next: (response) => {
        const blob = new Blob([response.body!], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'order_data.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        this.exportLoading = false;
      },
      error: (error) => {
        console.error('Error exporting orders:', error);
        this.exportLoading = false;
      }
    });
  }

  // Helper function to convert JS Date to ISO string
  private formatDate(date: Date): string {
    return date.toISOString(); // or .split('T')[0] if backend expects only yyyy-mm-dd
  }

  onClinicChange($event: any) {}

  resolveField(data: any, field: string): any {
    return field.split('.').reduce((acc, part) => acc && acc[part], data);
  }

  openSalesOrderDetails(order: any) {
    const ref = this.dialogService.open(OrderDetailsComponent, {
      header: 'Order Details',
      width: '70%',
      data: { order },
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        console.log('Order details closed with result:', result);
      }
    });
  }
}
